module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"pageInstructionDomain":"Инструкция по подключению домена"}}')
  delete Component.options._Ctor
}
